var degree=[
  {
    "val": 1,
    "text": "MBA / PGDM"
  },
  {
    "val": 2,
    "text": "CA"
  },
  {
    "val": 3,
    "text": "CS"
  },
  {
    "val": 4,
    "text": "ICWA"
  },
  {
    "val": 5,
    "text": "LLB / LLM"
  },
  {
    "val": 6,
    "text": "B Tech / BE"
  },
  {
    "val": 21,
    "text": " BArch"
  },
  {
    "val": 7,
    "text": "MBBS"
  },
  {
    "val": 8,
    "text": "BSc"
  },
  {
    "val": 9,
    "text": "BA"
  },
  {
    "val": 10,
    "text": "Bcom"
  },
  {
    "val": 11,
    "text": "BBA"
  },
  {
    "val": 19,
    "text": "BCA"
  },
  {
    "val": 13,
    "text": "PhD"
  },
  {
    "val": 14,
    "text": "MSc / MS / M Tech"
  },
  {
    "val": 20,
    "text": "MCA"
  },
  {
    "val": 15,
    "text": "MA"
  },
  {
    "val": 16,
    "text": "Integrated Masters Program"
  },
  {
    "val": 17,
    "text": "CFA"
  },
  {
    "val": 18,
    "text": "FRM"
  },
  {
    "val": 22,
    "text": "CWM"
  },
  {
    "val": 23,
    "text": "AFA"
  },
  {
    "val": 24,
    "text": "Passed CFA Level 1"
  },
  {
    "val": 25,
    "text": "Passed CFA Level 2"
  },
  {
    "val": 26,
    "text": "Passed CFA Level 3"
  },
  {
    "val": 27,
    "text": "PGDDA"
  },
  {
    "val": 12,
    "text": "Other"
  },
  {
    "val": 28,
    "text": "M.Com"
  },
  {
    "val": 29,
    "text": "BVSC"
  },
  {
    "val": 30,
    "text": "BAMS"
  },
  {
    "val": 31,
    "text": "BHMS"
  },
  {
    "val": 32,
    "text": "B.U.M.S"
  },
  {
    "val": 33,
    "text": "B.Pharma"
  },
  {
    "val": 34,
    "text": "BDS"
  },
  {
    "val": 35,
    "text": "Medical-MS/MD"
  },
  {
    "val": 36,
    "text": "MVSC"
  },
  {
    "val": 37,
    "text": "MDS"
  },
  {
    "val": 38,
    "text": "M.Ch"
  },
  {
    "val": 39,
    "text": "M.Sc"
  },
  {
    "val": 40,
    "text": "M.Sc Clinical Research"
  },
  {
    "val": 41,
    "text": "M.Sc. Biotechnology"
  },
  {
    "val": 42,
    "text": "Pharma D"
  },
  {
    "val": 43,
    "text": "MPH"
  },
  {
    "val": 44,
    "text": "MHA"
  },
  {
    "val": 45,
    "text": "M. Pharma"
  },
  {
    "val": 46,
    "text": "BNYS"
  },
  {
    "val": 47,
    "text": "D.Pharma"
  },
  {
    "val": 48,
    "text": "BPT"
  },
  {
    "val": 49,
    "text": "MPT"
  },
  {
    "val": 50,
    "text": "BPharma"
  },
  {
    "val": 51,
    "text": "M.Tech"
  }
]


export function getDegrees() {

    return degree.map(item => {
        return {
            label: item.text,
            value: item.val.toString(),
            key: item.val
        }
    })
}